export const SET_CURRENT_DATE_TIME = 'SET_CURRENT_DATE_TIME';
export const CURRENT_DATE_TIME_REQUEST = 'CUREENT_DATE_TIME_REQUEST';
export const CURRENT_DATE_TIME_FAILURE = 'CURRENT_DATE_TIME_FAILURE';
export const CURRENT_DATE_TIME_SUCCESS = 'CURRENT_DATE_TIME_SUCCESS';
